<template>
  <div class="clearfix">
    <a-upload
      v-show="!loading"
      list-type="picture-card"
      :file-list="fileList1"
      :remove="handleRemove"
      @change="handleChange"
      :beforeUpload="beforeUpload"
      :customRequest="doUpload"
      :disabled="disabled"
      @preview="handlePreview"
    >
      <div v-if="fileList1.length < maxCount">
        <app-icon type="icon-tianjia" />
        <div class="ant-upload-text">点击上传</div>
      </div>
    </a-upload>
    <div
      v-if="loading"
      style="
        width: 104px;
        height: 104px;
        line-height: 104px;
        text-align: center;
        border: 1px solid #dfdfdf;
        border-radius: 5px;
      "
    >
      上传中...
    </div>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
// import { UCloudUFile } from '@/utils/ufile-token'
import { webUpload } from '@/service/oss'
import moment from 'moment'
export default {
  data() {
    return {
      previewImage: null,
      previewVisible: false,
      loading: false,
    }
  },
  props: {
    fileList: {
      type: Array,
    },
    storeAs: {
      type: Function,
      default(file, key = '') {
        let suffix
        if (file.name) {
          suffix = file.name.match(/\.[^ .]+$/)[0]
        }
        return `${key}/${moment().format('YYYY/MM')}/${new Date().getTime()}${suffix}`
      },
    },
    uploadType: {
      type: String,
      default: 'image',
    },
    uploadOssType: {
      type: String,
      default: 'adminVisa',
    },
    maxCount: {
      type: Number,
      default: 5,
    },
    maxFileSize: {
      type: Number,
      default: 2000,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fileList1() {
      if (this.fileList && this.fileList.length > 0) {
        console.log('this.fileList', this.fileList);

        return this.fileList.map((item, index) => {
          // 后缀获取
          let matched = ''
          if (item) {
            matched = item.match(/[^/]+\.[^.]+$/)
          }
          const fileName = matched ? matched[0] : 'image.mp4'
          const fileItem = {
            uid: `-${index}`,
            name: fileName,
            status: 'done',
            originalUrl: item,
            url: item,
            response: {
              url: item,
            },
          }
          return fileItem
        })
      } else {
        return []
      }
    },
  },
  activated() {},
  mounted() {},
  methods: {
    handleRemove(file) {
      this.$emit('onremove')
    },
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {
      // if (!file.url && !file.preview) {
      //   file.preview = (await getBase64(file.originFileObj))
      // }
      // this.previewImage = file.url || file.preview
      // this.previewVisible = true
      window.open(file.response.url)
    },
    handleChange({ fileList }) {
      const srcList = fileList
        .filter(item => item.status === 'done' && item.response.url)
        .map(item => {
          return item.response.url
        })
      if (srcList.length) {
        this.$emit('onchange', srcList)
      }
    },
    beforeUpload(file) {
      const { uploadType, maxFileSize } = this

      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isVideo = file.type === 'video/mp4'
      if (uploadType.includes(',')) {
        const uploadTypes = this.uploadType.split(',')
        if (uploadTypes.includes('video') && uploadTypes.includes('image')) {
          if (!(isImage || isVideo)) {
            this.$message.error('请上传png、jpg格式图片文件或mp4格式视频文件!')
            return false
          }
        }
      }
      if (uploadType === 'image') {
        if (!isImage) {
          this.$message.error('请上传png、jpg格式图片文件!')
          return false
        }
      }
      if (uploadType === 'video') {
        if (!isVideo) {
          this.$message.error('请上传mp4格式视频文件!')
          return false
        }
      }
      const isLtSize = file.size / 1024 / 1024 < maxFileSize
      if (!isLtSize) {
        this.$message.error(`上传文件不能大于${maxFileSize}M!`)
        return false
      }
      this.loading = true
    },
    upLoading() {
      this.loading = false
    },
    doUpload(ev) {
      const { file, onError, onSuccess } = ev
      webUpload(file, this.uploadOssType).then(res => {
        if (res && res.data) {
          onSuccess()
          this.$emit('onchange', res.data)
        } else {
          onError(res)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.clearfix {
}
/* you can make up upload button and sample style by using stylesheets */
/* .ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
} */
</style>
